module.exports = __webpack_public_path__ + "img/instagramicon.e3f97221.svg";